import { STRAPI_URL } from "../../../lib/strapi";
import { STRINGS } from "../../../constants/strings";
import type { User, Organization } from "../../../types";

export interface LoginResponse {
  jwt: string;
  user: User;
}

export const loginRequest = async (email: string, password: string): Promise<LoginResponse> => {
  const response = await fetch(`${STRAPI_URL}/auth/local`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      identifier: email,
      password: password,
    }),
  });

  let data;
  try {
    data = await response.json();
  } catch (err) {
    if (!response.ok) {
      throw new Error(STRINGS.AUTH.SERVER_DOWN_ERROR(response.status));
    }
    throw new Error(STRINGS.AUTH.INVALID_RESPONSE_ERROR);
  }

  if (!response.ok) {
    throw new Error(data?.error?.message || STRINGS.AUTH.FAILED_TO_LOGIN);
  }

  return data;
};

export const fetchOrganizationsRequest = async (token: string): Promise<Organization[]> => {
  const response = await fetch(`${STRAPI_URL}/users/me?populate=organizations`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  
  if (!response.ok) {
    throw new Error(STRINGS.AUTH.FAILED_TO_FETCH_USER || "Failed to fetch user");
  }
  
  const user = await response.json();
  return user.organizations || [];
};
